import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../Store";
import {
  Typography,
  Box,
} from "@mui/material";
import { useSnackbar } from "../shared/SnackbarProvider";
import { Repo } from "../Repo";
import { formatDistanceToNow } from "date-fns";

const ManagerPage: React.FC = () => {
  const [trafficData, setTrafficData] = useState<any>(null);

  const snack = useSnackbar();
  const repo = new Repo();

  useEffect(() => {
    if (!trafficData) {
      repo.getDailyTrafficData().then((data) => {
        console.log("trafficData", data);
        setTrafficData(data);
      });
    }

  }, []);


  return (

    <Box sx={{ padding: 2 }}>
      <Typography variant="h4" gutterBottom>
        Daily Traffic
      </Typography>

      {trafficData && (
        <>
          <Typography variant="h6" gutterBottom>
            Via Burnham Beeches {trafficData.viaBurnhamBeeches.durationInTraffic} ({trafficData.viaBurnhamBeeches.delayMinutes} min delay)

          </Typography>

          <Typography variant="h6" gutterBottom>
            Via Dropmore {trafficData.viaDropmore.durationInTraffic} ({trafficData.viaDropmore.delayMinutes} min delay)
          </Typography>

          <Typography variant="h6" gutterBottom>
            Last updated: {formatDistanceToNow(new Date(trafficData.timestamp))} ago.
          </Typography>
        </>
      )}
    </Box>
  );
};


export default ManagerPage;
